import { React, Fragment, memo, useEffect, useState } from 'react'
import {
  BodyText,
  HeadingText,
  Button,
  PersonalInfoIcon,
  InformationIcon,
  WalletIcon,
  Row,
  Divider,
  Col,
  CaptionText,
} from '@paypalcorp/pp-react'

import { Message } from '@paypalcorp/worldready-react'
import { fptiCustomSetup, fptiCustomClick } from '../../../utils'
import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
import serverData from '../../../utils/server-data'

import {
  DATA_CORRECTION_ACCOUNT_URL,
  DATA_CORRECTION_WALLET_URL,
  DATA_CORRECTION_ACCOUNT_NATIVE,
  DATA_CORRECTION_WALLET_NATIVE,
} from '../../../constants/constants'

const DataCorrection = memo(() => {
  const correctionFpti = DATAPRIVACY_FPTI.CORRECTION

  const [impressionDone, setImpressionDone] = useState(false)
  const { isNative = false } = serverData
  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomSetup(correctionFpti.IMPRESSION)
    }
  }, [])
  const clickOnAccountSettingsBtn = (event) => {
    event.preventDefault()
    fptiCustomClick(correctionFpti.SETTINGS_BTN)
    location.href = isNative
      ? DATA_CORRECTION_ACCOUNT_NATIVE
      : DATA_CORRECTION_ACCOUNT_URL
  }
  const clickOnWalletBtn = (event) => {
    event.preventDefault()
    fptiCustomClick(correctionFpti.WALLET_BTN)
    location.href = isNative
      ? DATA_CORRECTION_WALLET_NATIVE
      : DATA_CORRECTION_WALLET_URL
  }
  return (
    <Fragment>
      <Row className="dataPrivacy-row">
        <Col>
          <HeadingText id="dataCorrectionHeader" size="sm">
            <Message id="dataCorrection.section.heading" />
          </HeadingText>
        </Col>
      </Row>

      <Divider />

      <Row className="dataPrivacy-row">
        <Col xs={2} md={1} className="text-center">
          <PersonalInfoIcon size="md" />
        </Col>
        <Col>
          <BodyText strong>
            <Message id="dataCorrection.section.subheader.title" />
          </BodyText>
          <BodyText>
            {isNative ? (
              <Message id="dataCorrection.section.subheader.mobile.desc" />
            ) : (
              <Message id="dataCorrection.section.subheader.desc" />
            )}
          </BodyText>
          <div className="dataPrivacy-correction-btn-row">
            <Button
              id="settingsBtn"
              size="sm"
              secondary
              onClick={clickOnAccountSettingsBtn}
            >
              {isNative ? (
                <Message id="dataCorrection.section.account.mobile.button" />
              ) : (
                <Message id="dataCorrection.section.account.button" />
              )}
            </Button>
          </div>
        </Col>
      </Row>
      <div className="dataPrivacy-correction-info-row">
        <InformationIcon className="info-item" size="sm" />

        <CaptionText className="info-item">
          <Message id="dataCorrection.section.account.info" />
        </CaptionText>
      </div>
      <Divider />
      <Row className="dataPrivacy-row">
        <Col xs={2} md={1} className="text-center">
          <WalletIcon size="md" />
        </Col>
        <Col>
          <BodyText strong>
            <Message id="dataCorrection.section.subheader.secondtitle" />
          </BodyText>
          <BodyText>
            <Message id="dataCorrection.section.subheader.seconddesc" />
          </BodyText>
          <div className="dataPrivacy-correction-btn-row">
            <Button
              id="walletBtn"
              size="sm"
              secondary
              onClick={clickOnWalletBtn}
            >
              {isNative ? (
                <Message id="dataCorrection.section.wallet.mobile.button" />
              ) : (
                <Message id="dataCorrection.section.wallet.button" />
              )}
            </Button>
          </div>
        </Col>
      </Row>

      <Divider />
    </Fragment>
  )
})
DataCorrection.displayName = 'DataCorrection'
export default DataCorrection
